import * as React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { getBaseUrl, isHomepageEshopEnabled, prop } from '../../utilities';
import { BreadcrumbsItems } from '../../constants';
import { buildBreadcrumbs } from '../_layout/Header/HeaderNew/menuData';
import IconLazy from '../_helpers/Icon/IconLazy';

const BreadcrumbsList = styled.map`
  color: #171717;
  font-size: ${rem(14)};
  line-height: ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    line-height: 1.4;
  }
`;

const BreadcrumbIconStyles = css`
  ${({ theme }) => theme.size(12)};
  fill: #808080;
`;

const BreadcrumbsBackIcon = styled(IconLazy)`
  ${BreadcrumbIconStyles};
  display: none;
`;

/* Odstup pod breadcrumbs je jednotný na celom webe a určuje ho výhradne tento
   komponent — mobil (do 991px) 10px, desktop (od 992px) 20px, merané od textu
   breadcrumbs po nasledujúci obsah. Skladá sa zo spodného paddingu položiek
   (4/10px) a margin-bottom holdera (6/10px); padding zároveň drží klikaciu
   plochu odkazov. Preto stránky pod breadcrumbs nesmú pridávať vlastný
   margin-top — inak sa odstup zase rozíde (viď Product/Category h1). */
const BreadcrumbsItemStyles = css`
  color: inherit;
  display: inline-block;
  padding: ${rem(4)} ${rem(3)} ${rem(4)} 0;
  ${({ theme }) => theme.media('md')} {
    padding-top: ${rem(6)};
    padding-bottom: ${rem(10)};
  }
`;

const BreadcrumbsLink = styled(Link)`
  ${BreadcrumbsItemStyles};
  text-decoration: underline;
  text-decoration-color: #cecece;
  &:hover,
  &:active,
  &:focus {
    text-decoration: underline;
  }
`;

const BreadcrumbsNoLink = styled.div`
  ${BreadcrumbsItemStyles};
  text-decoration: none;
  &:active,
  &:focus {
    text-decoration: none;
  }
`;

const BreadcrumbsSeparator = styled.span`
  display: inline-block;
  width: ${rem(8)};
  height: ${rem(8)};
  border-top: ${rem(1.5)} solid #808080;
  border-right: ${rem(1.5)} solid #808080;
  transform: rotate(45deg);
  margin: 0 ${rem(9)};
  vertical-align: middle;
  margin-left: ${rem(2)};
`;

const BreadcrumbsItemsHolder = styled.div`
  margin: 0 0 ${rem(6)} 0;
  ${({ theme }) => theme.media('md')} {
    margin-bottom: ${rem(10)};
  }
`;

interface BreadcrumbsProps {
  items?: BreadcrumbsItems;
  className?: string;
  lastAsLink?: boolean;
  mainMenu?: any;
  currentPath?: string;
  currentUniqs?: string[] | null;
  categoriesGroup?: any[];
  currentCategoryGroupId?: number;
  currentCategoryId?: number;
  settings?: any;
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { items, className, lastAsLink } = props;
  const computed =
    items && items.length
      ? buildBreadcrumbs(items as any, {
          mainMenu: props.mainMenu,
          currentPath: props.currentPath,
          currentUniqs: props.currentUniqs,
          categoriesGroup: props.categoriesGroup,
          currentCategoryGroupId: props.currentCategoryGroupId,
          currentCategoryId: props.currentCategoryId,
          eshopHomepage: isHomepageEshopEnabled(props.settings),
        })
      : [];

  const total = computed.length;

  return (
    <BreadcrumbsList className={className || ''}>
      <BreadcrumbsItemsHolder>
        {computed.map((item, i) => {
          const url = getBaseUrl(item.link || item.url || '');
          const isLast = i === total - 1;
          return (
            <React.Fragment key={i}>
              {i !== 0 ? <BreadcrumbsSeparator /> : ''}
              {total > 2 && i === total - 2 ? (
                <BreadcrumbsBackIcon icon="chevron" />
              ) : (
                ''
              )}
              {item.name &&
                (url && (!isLast || lastAsLink) ? (
                  <BreadcrumbsLink
                    to={url}
                    dangerouslySetInnerHTML={{
                      __html: item.name,
                    }}
                  ></BreadcrumbsLink>
                ) : (
                  <BreadcrumbsNoLink
                    dangerouslySetInnerHTML={{
                      __html: item.name,
                    }}
                  ></BreadcrumbsNoLink>
                ))}
            </React.Fragment>
          );
        })}
      </BreadcrumbsItemsHolder>
    </BreadcrumbsList>
  );
};

const mapStateToProps = (state: any) => ({
  mainMenu: prop(state, 'general.mainMenu.sitemap_tree'),
  currentPath: prop(state.routing, 'locationBeforeTransitions.pathname', ''),
  currentUniqs: prop(state, 'general.currentUniqs'),
  categoriesGroup: prop(state, 'general.categoriesGroup'),
  currentCategoryGroupId: prop(state, 'general.currentCategoryGroupId'),
  currentCategoryId: prop(state, 'general.currentCategoryId'),
  settings: prop(state, 'general.settings'),
});

export default connect(mapStateToProps)(Breadcrumbs);
